<template>
  <div>

    <vs-row v-if="prevPost.postId !== 0 || nextPost.postId !== 0 ">
      <vs-col class="header-tool mb-8" vs-type="flex" vs-justify="flex-end">
        <span v-if="prevPost.postId !== 0" @click="handleClickPrevPost">&lt; 이전글</span>
        <span v-if="prevPost.postId !== 0 && nextPost.postId !== 0 ">|</span>
        <span v-if="nextPost.postId !== 0" @click="handleClickNextPost">다음글 &gt;</span>
      </vs-col>
    </vs-row>

    <vx-card class="mb-8">

      <!--    제목-->
      <vs-row class="read-layout">
        <vs-col class="read-layout-title">제목</vs-col>
        <vs-col>
          <span class="ql-font-serif float-left">{{ post.post_title }}</span>
        </vs-col>
      </vs-row>

      <!--    작성자-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title">작성자</vs-col>
        <vs-col class="mr-8">
          <span v-if="post.author" class="text-sm">{{post.author.username}}</span>
          <span v-else class="text-sm">비회원</span>
        </vs-col>
        <vs-col class="read-layout-title">작성일</vs-col>
        <vs-col>
          <span class="text-sm">{{ post.created_at }}</span>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider></vs-divider>

      <!--    내용-->
      <vs-row class="read-layout">
        <vs-col class="read-layout-title top">내용</vs-col>
        <vs-col>
          <div class="content-read" v-html="post.post_content"></div>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider v-if="post.post_attachment && post.post_attachment.length > 0"></vs-divider>


      <!--    첨부파일-->
      <vs-row v-if="post.post_attachment && post.post_attachment.length > 0"
              class="read-layout">
        <vs-col class="read-layout-title top">첨부파일</vs-col>
        <vs-col>
          <vs-upload class="read-vs-upload" ref="vs_upload" :show-upload-button="false" disabled></vs-upload>
        </vs-col>
      </vs-row>

      <vs-row v-if="prevPost.postId !== 0" class="read-layout-footer">
        <vs-col class="read-layout-title">이전글</vs-col>
        <vs-col class="h-full pl-8">
          <span @click="handleClickPrevPost">{{prevPost.post_title}}</span>
        </vs-col>
      </vs-row>

      <vs-row v-if="nextPost.postId !== 0" class="read-layout-footer">
        <vs-col class="read-layout-title">다음글</vs-col>
        <vs-col class="h-full pl-8">
          <span @click="handleClickNextPost">{{nextPost.post_title}}</span>
        </vs-col>
      </vs-row>

    </vx-card>

    <!-- 댓글 달기 -->
    <vx-card class="add-comment mb-wide">
      <vs-row>
        <vs-col class="">
          <vs-textarea class="mb-0" rows="3" v-model="comment"/>
        </vs-col>
        <vs-col class="col-fix-buttons" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-button color="secondary" @click="(event)=>{ handleClickAddComment(event, this.comment, 0) }">등록하기</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>

    <vs-row class="mb-big-wide" vs-type="flex">
      <vs-col class="vs-button-list-left">
        <vs-row >
          <!-- 작성자인 경우 -->
          <vs-col v-if="isAuthor">
            <vs-button class="mr-2" color="secondary" type="border" @click="handleDeletePost">삭제</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col class="vs-button-list-right">
        <vs-row >
          <!-- 작성자인 경우 -->
          <vs-col v-if="isAuthor">
            <vs-button class="mr-2" type="border" @click="handleClickPostList">목록</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickRegister">글쓰기</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickReply">답글</vs-button>
            <vs-button class="" color="secondary" @click="handleClickModify">수정</vs-button>
          </vs-col>

          <!-- 작성자가 아닌 경우 -->
          <vs-col v-else>
            <vs-button class="mr-2" type="border" @click="handleClickPostList">목록</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickRegister">글쓰기</vs-button>
            <vs-button class="" type="border" @click="handleClickReply">답글</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <!--  댓글  -->
    <vx-card class="p-6 mb-wide">
      <div class="w-full flex" slot="no-body">
        <h5 class="mr-auto flex items-center">
          <b>댓글목록</b>
          <b class="ml-2 secondary">{{comments.length}}</b>
        </h5>
      </div>
    </vx-card>

    <vx-card >

      <div :data="comment" :key="index" v-for="(comment, index) in comments"
        class="comment-item" :class="`comment-item-${index}`" :style="{paddingLeft : (4.5 * comment.dep)+'rem'}">
        <vs-row class="comment-view mb-4">
          <vs-col>
            <vs-row class="comment-view-body">
              <vs-col class="col-img" >
                <vs-images hover="zoom" >
                  <vs-image class="w-full h-full" :src="comment.user_avatar"></vs-image>
                </vs-images>
              </vs-col>
              <vs-col class="pl-4" vs-type="grid" vs-align="center">
                <vs-col >
                  <span>{{comment.user_name}}</span>
                  <span class="ml-8">{{comment.created_at}}</span>
                </vs-col>
                <vs-col>{{comment.comment_content}}</vs-col>
              </vs-col>

            </vs-row>
          </vs-col>
          <vs-col
            v-if="comment.user_id === activeUserId"
            class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
            <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, index) }">답글</vs-button>
            <vs-button class="mr-2" type="border" text-color="black" @click="(event)=>{ openUpdate(event, index, comment) }">수정</vs-button>
            <vs-button class="" color="#eaeaea" text-color="black" @click="(event)=>{ handleClickDeleteComment(event, comment.comment_id) }">삭제</vs-button>
          </vs-col>
          <vs-col
            v-else
            class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
            <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, index) }">답글</vs-button>
          </vs-col>
        </vs-row>

        <vs-row class="comment-write" vs-type="flex">

          <vs-textarea class="w-full" rows="2" v-model="subComment[index]"/>
          <vs-button class="ml-auto mr-2" color="secondary" @click="(event)=>{ handleClickAddSubComment(event, index, comment.comment_id) }">등록</vs-button>
          <vs-button type="border" @click="(event)=>{ closeWrite(event, index) }">취소</vs-button>
        </vs-row>

      </div>

    </vx-card>
  </div>
</template>

<script>

export default {
  name: 'TemplateDetailNormal',

  props: {
    activeUserInfo: Object,
    isAuthor: { type: Boolean, default: false },

    post: Object,
    commentList: Array,
    subCommentList: Array,
    prevPost: Object, // prevPost = {title, postId}
    nextPost: Object // nextPost = {title, postId}
  },

  watch: {
    post () {
      const attachment = this.post.post_attachment
      for (let i = 0; i < attachment.length; i++) {
        this.setVsUploadImage(this, attachment[i].path)
      }
    },

    activeUserInfo () {
      this.activeUserId = this.activeUserInfo.id
    },

    commentList () {
      this.comments = this.commentList
    },

    subCommentList () {
      this.subComment = this.subCommentList
    }

  },

  data () {
    return {
      activeUserId:0,
      comment:'',
      comments:[],
      subComment:[],
      subCommentType:[]
    }
  },

  methods: {

    // vs-upload에 초기 이미지 넣기
    setVsUploadImage (_t, src) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }
        _t.$refs.vs_upload.srcs.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
        _t.$refs.vs_upload.filesx.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
      }
    },

    handleClickPrevPost () {
      this.$emit('handleClickPrevPost', this.prevPost)
    },

    handleClickNextPost () {
      this.$emit('handleClickNextPost', this.nextPost)
    },

    handleDeletePost () {
      this.$emit('handleDeletePost', this.post)
    },

    handleClickPostList () {
      this.$emit('handleClickPostList')
    },

    handleClickModify () {
      this.$emit('handleClickModify', this.post)
    },

    handleClickRegister () {
      this.$emit('handleClickRegister')
    },

    handleClickReply () {
      this.$emit('handleClickReply', this.post)
    },

    handleClickAddComment (event, comment, parentId) {
      this.$emit('handleClickAddComment', this.post, comment, parentId)
    },

    handleClickAddSubComment (event, index, commendId) {
      const comment = this.subComment[index]
      const parentId = commendId
      const addCommentType = this.subCommentType[index]

      if (addCommentType === 'c') {
        this.$emit('handleClickAddComment', this.post, comment, parentId)
      }
      if (addCommentType === 'u') {
        this.$emit('handleClickUpdateComment', this.post, comment, commendId)
      }
    },

    handleClickDeleteComment (event, commentId) {
      this.$emit('handleClickDeleteComment', this.post, commentId)
    },

    openWrite (event, index) {
      this.subCommentType[index] = 'c'
      document.getElementsByClassName(`comment-item-${index}`)[0].children[1].classList.add('open')
    },

    openUpdate (event, index, comment) {
      this.subCommentType[index] = 'u'
      document.getElementsByClassName(`comment-item-${index}`)[0].children[1].classList.add('open')
    },

    closeWrite (event, index) {
      document.getElementsByClassName(`comment-item-${index}`)[0].children[1].classList.remove('open')
    }
  }
}
</script>

<style scoped>
.content-head {
  width: 100px;
  font-weight: bold;
}

.content-read {
  min-height: 20em;
  line-height: 1.6;
}

.read-layout,
.read-layout-2 {
  margin-bottom:1.5rem;
}

.read-layout {
  display: grid !important;
  grid-template-columns: 60px 1fr;
}
.read-layout-2 {
  display: grid !important;
  grid-template-columns: 60px auto 60px 1fr;
}
.read-layout-title {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.read-layout-title.top{
  align-items: start;
}

.read-layout-footer{
  width: auto !important;
  height:50px;
  display:  grid !important;
  grid-template-columns: 120px 1fr;
  align-items: center;

  margin-left:-1.5rem;
  margin-right:-1.5rem;
  border-top:1px solid #f2f2f2 !important;
}
.read-layout-footer .read-layout-title{
  height:100%;
  justify-content: center;

  background-color: #EDEDED;
}
.read-layout-footer span {
  height:100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.read-layout-footer:last-child {
  margin-bottom:-1.5rem;
}

.add-comment .vs-row {
  display: grid !important;
  margin-right:-1.5rem;
  grid-template-columns: minmax(0%, 100%) 12rem;
}

.mb-wide { margin-bottom:1.5rem !important;}
.mb-big-wide { margin-bottom:4.5rem !important; }
.vs-button-list-left { width:auto !important; }
.vs-button-list-right { width:auto !important; margin-left:auto !important;}

b.secondary { color: rgb(102,112,203)}

.comment-item {
  border-bottom: 1px solid #EAEAEA;
  margin-bottom: 1.5rem;
}
.comment-item:last-child{
  border-bottom:none;
  margin-bottom: 0;
}


.comment-item.sub-1 {
  padding-left: 4.5rem;
}
.comment-item.sub-2 {
  padding-left: 9rem;
}
.comment-item.sub-3 {
  padding-left: 13.5rem;
}
.comment-view {
  display: grid !important;
  grid-template-columns: minmax(0%,100%) 300px;
}
.comment-view-body {
  display: grid !important;
  grid-template-columns: 70px minmax(0%,100%);
  grid-template-rows:70px;
}
.comment-write{
  margin-top:1.5rem;
  margin-bottom:1.5rem;

  display: none !important;
}
.comment-write.open{
  display: flex !important;
}
</style>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}

.read-vs-upload .btn-x-file {
  visibility: hidden;
}

.add-comment .vx-card__collapsible-content .vx-card__body {
  padding-right:0px !important;
}

.col-img .vs-image--img{
  background-color: #C4C4C4 !important;
}

.comment-item .con-vs-image .vs-image--img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
